export default __webpack_public_path__ + "static/media/PERFIL_EMPRENDEDOR.c71a5cb2.png";